import { Injectable } from '@angular/core';
import { AngularFirestore, QueryFn } from '@angular/fire/compat/firestore';
import { firstValueFrom } from 'rxjs';

import UniqueEntityID from '../../../core/domain/unique_entity_id';
import {
  PredefinedTask,
  TaskDelay,
  TaskStatus,
  TaskTargetType,
  TaskType,
} from '../domain/predefined-task';

export interface PredefinedTaskSchema {
  type: TaskType;
  isNameable: boolean;
  description: string;
  delay: TaskDelay | null;
  targetType: TaskTargetType;
  status: TaskStatus;
  sort: number | null;
}

@Injectable()
export class PredefinedTaskRepository {
  constructor(private firestore: AngularFirestore) {
    // Nada
  }

  private collection(queryFn?: QueryFn) {
    return this.firestore.collection<PredefinedTaskSchema>(
      'predefined_tasks',
      queryFn,
    );
  }

  static fromSchema(schema: PredefinedTaskSchema, id?: string): PredefinedTask {
    return PredefinedTask.create(
      {
        type: schema.type,
        isNameable: schema.isNameable ?? false,
        description: schema.description,
        delay: schema.delay ?? undefined,
        targetType: schema.targetType,
        status: schema.status,
      },
      new UniqueEntityID(id),
    );
  }

  async findAll(): Promise<PredefinedTask[]> {
    const snap = await firstValueFrom(
      this.collection((ref) =>
        ref.where('status', '==', 'ACTIVE').orderBy('sort', 'asc'),
      ).get(),
    );
    return snap.docs.map((doc) =>
      PredefinedTaskRepository.fromSchema(doc.data(), doc.id),
    );
  }
}
